var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2754 28.688C27.6077 28.688 28.6878 27.6079 28.6878 26.2755C28.6878 24.9431 27.6077 23.863 26.2754 23.863C24.943 23.863 23.8629 24.9431 23.8629 26.2755C23.8629 27.6079 24.943 28.688 26.2754 28.688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.0595 29.6471L52.5509 26.2754L32.0595 22.9038L38.1633 14.3875L29.6471 20.4914L26.2754 0L22.9038 20.4914L14.3875 14.3875L20.4913 22.9038L0 26.2754L20.4913 29.6471L14.3875 38.1633L22.9038 32.0595L26.2754 52.5509L29.6471 32.0595L38.1633 38.1633L32.0595 29.6471Z",
    fill: "#FEB12F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.2838 28.3101L41.6803 26.2755L29.2838 24.2263L31.7253 20.8256L28.3246 23.2671L26.2755 10.8706L24.2409 23.2671L20.8256 20.8256L23.2671 24.2263L10.8706 26.2755L23.2671 28.3101L20.8256 31.7253L24.2409 29.2838L26.2755 41.6803L28.3246 29.2838L31.7253 31.7253L29.2838 28.3101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStar);
export default __webpack_public_path__ + "static/media/project-star.5e88ee81df58402636e01371c1930276.svg";
export { ForwardRef as ReactComponent };